/* eslint-disable */ // Provides an entity CRUD mixin for Drupal Entities.
<script>
import axios from "axios";
import DrupalToken from "./DrupalToken.vue";

export default {
  props: ["entity-storage", "entity-resource-endpoint", "entity-id-field"],
  mixins: [DrupalToken],
  data() {
    return {
      entityObject: this.createEntityObject(),
    };
  },
  methods: {
    createEntity(endpoint, entity) {
      return this.getToken().then(function (response) {
        let token = response.data;
        return axios.post(endpoint + "?_format=json", entity, {
          responseType: "json",
          headers: { "X-CSRF-Token": token },
        });
      });
    },
    readEntity(endpoint, params) {
      // @todo this is untested since it isnt used yet.
      // @todo check permissions...this doesn't work with 'api_key_auth', only 'cookie' authentication
      return axios.get(endpoint, {
        responseType: "json",
        params: params,
      });
    },
    listEntities(endpoint, params) {
      return axios.get(endpoint, {
        responseType: "json",
        params: params,
        headers: { "Cache-Control": "max-age=120" },
      });
    },
    updateEntity(endpoint, params) {
      // Perform an update request.
      return this.getToken().then((response) => {
        let token = response.data;
        // Create a json object for Drupals REST Api.
        return axios.patch(endpoint + "?_format=json", params, {
          responseType: "json",
          headers: { "X-CSRF-Token": token },
        });
      });
    },
    deleteEntity(endpoint) {
      return this.getToken().then(function (response) {
        let token = response.data;
        // Create a json object for Drupals REST Api.
        return axios.delete(endpoint + "?_format=json", {
          responseType: "json",
          headers: { "X-CSRF-Token": token },
          params: { _format: "json" },
        });
      });
    },
    createEntityObject() {
      return {
        title: [null],
      };
    },
  },
};
</script>
